import { FC, useRef, useState } from "react";
import { GradientButton, PhoneFrame } from "./components";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle, UploadSimple } from "phosphor-react";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "src/services/firebase";
import { api } from "src/services/api";

export const SendCCMEI: FC = () => {
	const location = useLocation();

	const { accountType } = location.state;

	const navigate = useNavigate();

	const documentInputRef = useRef<any>(null);

	const [loading, setLoading] = useState(false);
	const [document, setDocument] = useState<any>(null);

	const handleDocumentUpload = () => {
		documentInputRef?.current?.click();
	};

	const handleSelectDocument = (event: any) => {
		const file = event.target.files[0];

		if (file) {
			if (file.size > 10 * 1024 * 1024) {
				alert("O arquivo deve ter no máximo 10MB.");
				return;
			}
			setDocument(file);
		}
	};

	const handleSavePhoto = async () => {
		if (!document) {
			return;
		}

		setLoading(true);
		const storageRef = ref(storage, `documents/${document.name}`);
		const documentUploadTask = uploadBytesResumable(storageRef, document);
		documentUploadTask.on(
			"state_changed",
			() => {},
			(error) => {
				console.log(error);
			},
			async () => {
				const documentUri = await getDownloadURL(
					documentUploadTask.snapshot.ref,
				);
				if (documentUri) {
					localStorage.setItem("@yntech:ccmei", documentUri);

					setLoading(false);
					navigate("/create-account-wallet/invoicing-alert", {
						state: { accountType },
					});
				}
				setLoading(false);
			},
		);
	};

	return (
		<div className="w-full h-screen flex justify-center items-center gap-20 background max-2xl:gap-0">
			<PhoneFrame
				onPress={() =>
					navigate("/create-account-wallet/pj-alert", {
						state: { accountType },
					})
				}
			/>

			<div className="bg-[#7C7775]/80 max-w-[50%] rounded-2xl p-[4%] border-2 border-black">
				<div className="w-full">
					<p className="text-white font-extralight text-3xl">
						Faça o upload do seu arquivo em PDF
					</p>

					<h3 className="text-[#AA7339] font-extralight text-sm mt-3">
						Atenção o arquivo deve ter no máximo o tamanho de 10mb.
					</h3>

					<h3 className={`text-white font-extralight text-base mt-3 mb-3`}>
						Selecione a foto em seu computador:
					</h3>
					<input
						type="file"
						accept=".pdf,.doc,.docx,.odt"
						onChange={handleSelectDocument}
						ref={documentInputRef}
						style={{ display: "none" }}
					/>

					<button
						onClick={handleDocumentUpload}
						className={`w-full h-48 rounded-2xl bg-white flex items-center justify-center mt-3 mb-3`}
					>
						{document !== null ? (
							<CheckCircle color="#4BBD9C" size={50} />
						) : (
							<UploadSimple color="#CFCFCF" size={32} />
						)}
					</button>

					<div className="flex gap-4 mt-10">
						<GradientButton
							title="Voltar"
							tailwindStyles="bg-[#171717] text-white w-[8rem] xl:w-[16rem] h-12 lg:h-16 text-white p-texte"
							onClick={() =>
								navigate("/create-account-wallet/pj-alert", {
									state: { accountType },
								})
							}
						/>
						<GradientButton
							isLoading={loading}
							title="Avançar"
							tailwindStyles="bg-[#AA7339] text-white w-[8rem] xl:w-[16rem] h-12 lg:h-16 text-white p-texte"
							onClick={handleSavePhoto}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
